import React from 'react';
import axios from 'axios';

import Parrilla from '../../Components/Parrilla/Parrilla';
import UniffiMixesModal from './UniffiMixesModal';

class UniffiMixesPage extends React.Component {

	state = {
		rows: [],
		page: 1,
		nextPage: null,
		prevPage: null,
		lastPage: null,
		sort: 'UniffiMixes.code',
		direction: 'asc',
		field: null,
		query: null,
		modalOpened: false,
		modalId: ''
	}

	async componentDidMount() {
		const self = this;

		// Execute initial actions
		await self.loadParrillaData();
	}

	async loadParrillaData() {
		const self = this;

		// Auth Headers
		let authHeaders = await window.prepareAuthHeaders();

		// Get token from python
		await axios.get(
			window.API_URL + '/uniffimixes/list',
			{	
				params: {
					page: self.state.page,
					sort: self.state.sort,
					direction: self.state.direction,
					field: self.state.field,
					query: self.state.query
				},
				headers: authHeaders
			}
		).then((response) => {
			self.setState((state) => {
				if ( response.data ) {
					state.rows = response.data.rows;
					state.page = response.data.page;
					state.nextPage = response.data.nextPage;
					state.prevPage = response.data.prevPage;
					state.lastPage = response.data.lastPage;
				}
				return state;
			});
		});
	}

	parrillaSortCallback(key) {
		const self = this;

		// Update State
		self.state.sort = key;
		self.state.direction = self.state.direction === 'asc' ? 'desc' : 'asc';

		// Reload data
		self.loadParrillaData();
	}

	parrillaChangePageCallback(page) {
		const self = this;

		// Set page
		self.state.page = page;

		// Reload data
		self.loadParrillaData();
	}

	parrillaSearchCallback(field, query) {
		const self = this;

		// Set page
		self.state.field = field;
		self.state.query = query;

		// Reload data
		self.loadParrillaData();
	}

	openModal(event, idx = null) {
		const self = this;

		// Prevent
		if ( event ) event.preventDefault();

		// Set modal opened
		self.setState((state) => {
			state.modalOpened = true;
			state.modalId = idx !== null ? self.state.rows[idx].id : null;
			return state;
		});
	}

	closeModal() {
		const self = this;

		// Set modal opened
		self.setState((state) => {
			state.modalOpened = false;
			state.modalId = '';
			return state;
		});

		// Reload parrilla
		self.loadParrillaData();
	}

	render() {
		const self = this;

		// Prepare header
		let header = [
			{ text: 'Código', key: 'UniffiMixes.code', width: 100 },
			{ text: 'Descripción', key: 'UniffiMixes.description', width: 200 },
			{ text: 'Cliente', key: 'Clients.name', width: 100 },
			{ text: 'Precio', key: 'price_total', width: 100 },
			{ text: 'Proteina B', key: 'UniffiMixes.protein_percent', width: 100 },
			{ text: 'Fibra B', key: 'UniffiMixes.fiber_percent', width: 100 },
			{ text: 'Aceite B', key: 'UniffiMixes.fat_percent', width: 100 },
			{ text: 'Ceniza B', key: 'UniffiMixes.ashes_percent', width: 100 },
		];

		// Prepare rows
		let rows = [];
		if ( self.state.rows ) self.state.rows.forEach((el, idx) => {
			let tmpRow = [];
			tmpRow.push(
				{text: el.code, align: 'left'},
				{text: el.description, align: 'left'},
				{text: el.client ? el.client.name : '', align: 'left'},
				{text: el.price_total ? el.price_total.toFixed(2) : 0, align: 'right'},
				{text: el.protein_percent ? el.protein_percent.toFixed(2) : 0, align: 'right'},
				{text: el.fiber_percent ? el.fiber_percent.toFixed(2) : 0, align: 'right'},
				{text: el.fat_percent ? el.fat_percent.toFixed(2) : 0, align: 'right'},
				{text: el.ashes_percent ? el.ashes_percent.toFixed(2) : 0, align: 'right'},

			);
			rows.push(tmpRow);
		});

		// Prepare searchFields
		let searchFields = [
			{ text: 'Código', key: 'UniffiMixes.code' },
			{ text: 'Descripción', key: 'UniffiMixes.description' },
			{ text: 'Cliente', key: 'Clients.name' }
		];

		// Render
		return (
			<React.Fragment>
				<Parrilla 
					title="50.5 Uniffi"

					header={header} 
					rows={rows} 

					sortCallback={(key) => self.parrillaSortCallback(key)}
					clickRowCallback={(idx) => self.openModal(null, idx)}

					paginator={{page: self.state.page, prevPage: self.state.prevPage, nextPage: self.state.nextPage, lastPage: self.state.lastPage}}
					pageChangeCallback={(page) => self.parrillaChangePageCallback(page)}

					btnAdd={true}
					btnAddCallback={(event) => self.openModal(event, null)}

					btnSearch={true}
					searchFields={searchFields}
					clickSearchCallback={(field, query) => self.parrillaSearchCallback(field, query)}
				></Parrilla>

				{ self.state.modalOpened === true &&
					<UniffiMixesModal 
						id={self.state.modalId}
						close={() => self.closeModal()}
					/>
				}	
			</React.Fragment>
		);
	}
}

export default UniffiMixesPage;
